import { Controller } from "@hotwired/stimulus";

// Turbo renders a failed submission's body; an empty one (`head :not_found`) or a network error changes nothing.
export default class extends Controller {
  static targets = ["template", "flash"];

  async reveal({ detail: { success, fetchResponse } }) {
    if (success || (await this.#rendered(fetchResponse))) return;

    this.flashTarget.replaceChildren(this.templateTarget.content.cloneNode(true));
  }

  async #rendered(fetchResponse) {
    if (!fetchResponse?.isHTML) return false;

    return (await fetchResponse.responseHTML).trim().length > 0;
  }
}
